<div id="top"></div>
  <app-publicnavbar  ></app-publicnavbar>

  



<div #details tabindex="-1">
  <br>
  <br>
  <div id="swagger-ui">

  </div>
 
  
</div>